import GridList from './GridList.view';

export default GridList;
